import React from "react";
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function RoleRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "citizen" ? "/portal" : "/dashboard"} replace />;
}
